const processingApplicationQuestionnaires = {
        "title": "調查表",
        "sections": [
            {
                "subject": "申請者基本資料",
                "questions": [
                    {
                        "description": "您是否擁有一份現行的有機標準?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "您是否清楚了解現行的有機標準?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "您是否有先前或現在申請的有機驗證機構?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請列出先前或現在申請的有機驗證機構名稱、申請年份、標準和驗證結果。",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["標準", "驗證機構", "年份", "結果"]
                            }
                        }]
                    },
                    {
                        "description": "您是否曾被任何驗證機構否決、暫停、撤銷驗證，或曾收到不符合通知?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請說明原因及該驗證機構名稱，並請提供上述事項的通知文件及有關已修正改善的書面確認函。",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["驗證機構名稱", "原因", "上傳檔案: file"]
                            }
                        }]
                    },
                    {
                        "description": "請提供前往查驗地點之路線說明：(可另附件說明)",
                        "type": "oeq",
                        "format": {
                            "multiple": false,
                            "fields": ["說明", "附件: file"]
                        }
                    },
                    {
                        "description": "是否所有必須被驗證的設施與設備都在同一個地方?",
                        "type": "seq",
                        "options": ["是", "否"],
                        "questions":[{
                            "condition": "否",
                            "description": "請提供各設備的所在地點名稱及地址。",
                            "type": "oeq",
                            "format": {
                                "multiple": true,
                                "fields": ["設備所在地點", "地址"]
                            }
                        }]
                    },
                    {
                        "description": "除有機加工、分裝及流通作業外，您是否也進行非有機加工、分裝及流通作業?",
                        "type": "seq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請列出或說明您生產的非有機產品的種類及名稱",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "加工、分裝流通(廠)場周圍是否有「有害氣體、輻射性物質、擴散性污染源、垃圾場及有害生物」之污染問題？",
                        "type": "seq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請說明何種污染源",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "請勾選非自行操作之相關業務",
                        "type": "mcq",
                        "options": ["不適用", "原料處理", "生產製造", "包裝作業", "技術提供", "產品銷售", "場地、設備", "其他"],
                        "questions": [{
                            "condition": "(原料處理|生產製造|包裝作業|技術提供|產品銷售|場地、設備|其他)",
                            "description": "若有非自行操作之部分, 請說明該合作者(個人或機構)之姓名或名稱",
                            "type": "oeq"
                        }]
                    },
                ]
            },
            {
                "subject": "標示方法及產品成份",
                "description": ["申請NOP驗證的客戶，所有申請有機驗證的產品需附上成品標籤樣張，設計產品標示時可參考本公司之「標示審查表單」(請至附件區下載)。"],
                "questions": [
                    {
                        "description": "是否有“可追溯的批號”管理?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請敘述批號代表意義(例:S08191204  S代表有機大豆 08代表第八號倉庫 191204代表2019年12月4號生產)",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "在成份敘述中，有機成份是否被標示為“有機”？",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "標籤之資訊版面上是否顯示“由慈心有機驗證股份有限公司驗證”的字樣?(僅適用於申請NOP)",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "標示中敍述有機成分之用語與百分比註明，是否與其他說明使用相同顏色、同樣大小與字體?(僅適用於申請NOP)",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "僅供出口到國際市場之非零售用容器上的標示和文件是否標明“僅供外銷”之字樣?(僅適用於申請NOP)",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "驗證機構代碼是否標示於與歐盟有機標章相同之視線內?(僅適用於申請歐盟)",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "是否有明顯標示歐盟標章於產品標示上?(僅適用於申請歐盟)",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "是否依其農業原料的所在地於驗證機構代碼下方標示 ”non-EU Agriculture”、”EU Agriculture” 或 “EU/non-EU Agriculture“?(僅適用於申請歐盟)",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "是否按原料的重量/容積大小依序列出產品所含成份，並列出所有添加物全名?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "是否已訂定原料供應商管理辦法?",
                        "type": "scq",
                        "options": [{"value": "是", "elaboration": "請提供相關文件，另請備妥記錄供現場稽核時查核:file, multiple"}, "否"],
                    },
                    {
                        "description": "原料入庫前是否有做檢查?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "是否做成紀錄?",
                            "type": "scq",
                            "options": ["是", "否"]
                        }]

                    },
                    {
                        "description": "“有機產品原料明細表”中所有列為「有機」的原料是否有相關之“有機證件”?",
                        "type": "scq",
                        "options": ["是", "否", "不適用"]
                    },
                    {
                        "description": "“有機產品原料明細表”中所列的「有機」加工助劑是否有相關之“有機證件”?",
                        "type": "scq",
                        "options": ["是", "否", "不適用"]
                    },
                    {
                        "description": "對於標示為‟100%有機”和‟有機”的產品，如使用非有機的農產品原料，您是否保有“有機原料市面無法獲得”的相關文件?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "對於標示為‟100%有機”和‟有機”的產品，同一種原料中是否混合使用有機、有機轉型期和非有機來源者?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "對於標示為‟100%有機”和‟有機”的產品，是否使用任何非允用的合成物質或合成溶劑?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "是否在生產或處理過程使用亞硫酸塩、硝酸塩、亞硝酸塩?(僅適用於申請NOP)",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "如是，請列出使用亞硫酸塩、硝酸塩、亞硝酸塩的所有有機產品」",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "非有機原料(農產與非農產)是否符合相關有機標準的規定?",
                        "type": "scq",
                        "options": ["是", "否", "不適用"]
                    },
                    {
                        "description": "副產品是否以“有機”名義販售?",
                        "type": "scq",
                        "options": ["是", "否", "不適用"],
                        "questions": [{
                            "condition": "是",
                            "description": "請列出所有產品名稱",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "製程中是否用到水(包含原料、加工助劑、烹煮、冷却、消毒、清洗器具設備等)?",
                        "type": "scq",
                        "options": ["是", "否(請直接跳答下一節)"],
                        "questions": [
                            {
                                "condition": "是",
                                "description": "請說明用途",
                                "type": "oeq"
                            },
                            {
                                "condition": "是",
                                "description": "請說明製程用水來源",
                                "type": "scq",
                                "options": ["自來水", "地下水", {"value": "其他", "elaboration": "請說明"}],
                                "questions": [
                                    {
                                        "condition": "(地下水||其他)",
                                        "description": "製程用水是否符合當地政府的飲用水水質標準?",
                                        "type": "scq",
                                        "options": ["是", "否"]
                                    },
                                    {
                                        "condition": "(地下水||其他)",
                                        "description": "用水是否經淨水或過濾處理?",
                                        "type": "scq",
                                        "options": ["是", "否"],
                                        "questions": [{
                                            "condition": "是",
                                            "description": "請說明如何處理",
                                            "type": "oeq"
                                        }]
                                    },
                                    {
                                        "condition": "(地下水||其他)",
                                        "description": "使用非自來水於食品加工製程時，是否每年檢送政府或本公司認可之檢驗機構檢驗?",
                                        "type": "scq",
                                        "options": ["是", "否", "不適用"]
                                    },
                                ]
                            },
                            {
                                "condition": "是",
                                "description": "水質是否有被監測?",
                                "type": "scq",
                                "options": [{"value": "是", "elaboration": "請說明如何監測"}, "否"],
                            },
                            {
                                "condition": "是",
                                "description": "是否使用蒸汽?",
                                "type": "scq",
                                "options": ["是", "否"],
                                "questions": [{
                                    "condition": "是",
                                    "description": "蒸氣是否直接接觸有機產品?",
                                    "type": "scq",
                                    "options": ["是", "否"],
                                    "questions": [{
                                        "condition": "是",
                                        "description": "鍋爐是否使用水處理劑?",
                                        "type": "scq",
                                        "options": ["是", "否"],
                                        "questions": [{
                                            "condition": "是",
                                            "description": "如是請列出水處理劑名稱，並附上SDS 及/或相關標籤",
                                            "type": "oeq",
                                            "format": {
                                                "multiple": true,
                                                "fields": ["名稱", "上傳檔案: file"]
                                            }
                                        }]
                                    }]
                                }]
                            }
                        ]
                    }
                ]
            },
            {
                "subject": "有機完整性的確保",
                "description": [
                        "有機作業過程中必須避免有機產品受到非有機產品，或是禁用物質的污染。",
                        "包裝材料、箱子，和儲放容器必須確保未含合成殺菌劑、防霉劑或防腐劑。",
                        "重覆使用的包裝材料或容器必須清潔並確保不會影響有機完整性。",
                        "用以維護有機完整性的措施必須保留紀錄。"
                ],
                "questions": [
                    {
                        "description": "請上傳【有機完整性計畫】，並指出潛在性混雜及∕或污染的關鍵點，以及執行管理方案與實際隔離設施、以防止平行生產時，有機與非有機產品的混雜，並且防止有機生產、管理作業與產品和禁用物質接觸。",
                        "type": "ocq",
                        "format": {
                            "multiple": false,
                            "fields": ["上傳檔案:file, optional"]
                        }
                    },
                    {
                        "description": "所使用之設備、容器與器具，其操作、使用與維護是否能避免食品遭受污染?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "於製程中是否有相關之管制標準?(例如：溫度、濕度、pH、水活性…)",
                        "type": "scq",
                        "options": [{"value": "是", "elaboration": "請說明"}, "否"]
                    },
                    {
                        "description": "您是否執行品質確保計畫？",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "若是，您執行的計畫是?",
                            "type": "scq",
                            "options": ["ISO", "HACCP", "TQM", {"value": "其他", "elaboration": "請說明"}]
                        }]
                    },
                    {
                        "description": "品質監測:(請勾選適用者)",
                        "type": "mcq",
                        "options": ["原料購買前之檢驗", "進料時之檢驗", "生產過程中之檢驗", "成品檢驗", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "製程及品質管制有異常時，是否建立矯正及防止再發生之措施並作成紀錄?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "您採取什麼措施以防止使用以禁用方法(基因改造)、下水道污泥或放射線照射等生產的原料?",
                        "type": "mcq",
                        "options": ["基因改造成分檢驗", "生產者保證信", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "您是否制訂產品召回和銷毀計劃?",
                        "type": "scq",
                        "options": [{"value": "是", "elaboration": "請上傳檔案:file, multiple"}, "否"],
                    },
                    {
                        "description": "製程中涉及之設備、儀器需做成校正者，是否有做內、外校正?",
                        "type": "scq",
                        "options": ["是", "否", "不適用"],
                        "questions": [{
                            "condition": "是",
                            "description": "請說明校正頻率",
                            "type": "oeq",
                            "format": {
                                "multiple": false,
                                "fields": ["內校", "外校"]
                            }
                        }]
                    },
                    {
                        "description": "請列出在生產中使用到的所有設備(設備清洗/清理紀錄應涵蓋設備名稱，並敍述清洗方式及清洗頻率。清洗/清理方式：放入有機材料、清掃、擦拭、吸/集塵、高壓/空氣槍噴、水洗、蒸氣清潔、消毒、刮除、CIP等。)",
                        "type": "oeq",
                        "format": {
                            "multiple": true,
                            "fields": ["設備名稱", "是否保有清潔紀錄:是|否", "執行有機生產之前會清洗/清理方式", "執行有機生產前如以放入有機原料清理，請說明清理程序、使用數量、清理後有機原料處理方式"]
                        }
                    },
                    {
                        "description": "所有設備是否只用來輸送、製造加工、與/或儲存有機產品?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": " 如使用同一套設備於有機與非有機產品之製造加工，是否採取防範措施以維護有機之完整性?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請說明如何防範",
                            "type": "oeq",
                        }]
                    },
                    {
                        "description": "所使用之清潔、消毒劑是否符合相關法規標準?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "請提供您使用的清潔計劃和清潔用品的資料:",
                        "type": "oeq",
                        "format": {
                            "multiple": true,
                            "fields": ["地區:進貨區|原料儲藏區|產品轉運區|生產區|包裝區|成品儲藏區|出貨區|廠外環境|其他", "清潔方式", "使用的清潔工具", "使用的清潔用品", "使用頻率", "保有清潔紀錄:是|否"]
                        }
                    },
                    {
                        "description": "是否測試食品接觸面或清洗後廢水以避免清潔用品殘留物污染有機產品?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "請勾選使用的包裝材料",
                        "type": "mcq",
                        "options": ["紙", "硬卡紙板", "木料", "玻璃", "金屬", "鋁箔", "塑膠", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "是否所有的包裝材料皆皆符合食品衛生安全及品質之標準？",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "是否有回收重覆使用的包裝材料？",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請說明再重複使用前如何清理?",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "重複使用的包裝材料是否有機與非有機產品共用？",
                        "type": "scq",
                        "options": ["是", "否", "不適用"],
                        "questions": [{
                            "condition": "是",
                            "description": "請說明如何防止交叉汙染：",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "請填妥下表，以提供儲藏區資料:",
                        "type": "oeq",
                        "format": {
                            "multiple": true,
                            "fields": ["用途:原料儲藏區|包裝材料儲藏區|半成品儲藏區|成品儲藏區|廠外儲藏區|其他", "地點", "儲藏方式/容量", "儲藏區辨識名稱或編號",
                                        "是否專供有機使用:是|否", "評斷遭受混染或污染的可能性"]
                        }
                    },
                    {
                        "description": "有機儲藏區域是否有明確的識別標示？",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "是否有機與非有機產品儲藏在同一地方？",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請列出防止汙染或混雜的措施",
                            "type": "oeq"
                        }]
                    },
                    {
                        "description": "請說明原料進貨的包裝方式?",
                        "type": "mcq",
                        "options": ["散裝乾貨", "網袋", "液態桶/桶裝", "鋁箔袋", "金屬桶", "紙桶", "硬卡紙箱", "紙袋", "塑膠器皿", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "進貨時，您是否自行做運送?",
                        "type": "mcq",
                        "options": ["自己", "委外"],
                        "questions": [{
                            "condition": "委外",
                            "description": "如果委由運送公司運送，您是否告知他們有機加工分裝流通的要求？",
                            "type": "scq",
                            "options": ["是", "否"]
                        }]
                    },
                    {
                        "description": "運送工具是否也運送非有機產品或禁用資材?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "如“是”，您如何確保進貨的交通工具在載運有機產品前已徹底清潔，以避免污染？",
                            "type": "oeq",
                        }]
                    },
                    {
                        "description": "前述檢查清潔過程是否做成紀錄？",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "有機產品和非有機產品，是否同時使用同一工具運送?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "如 “是”，請勾選隔離有機產品的措施?",
                            "type": "mcq",
                            "options": ["使用不同的棧板", "棧板標示「有機」", "以收縮膜包覆有機產品", "在運送工具內分區", "裝在密閉容器裡", {"value": "其他", "elaboration": "請說明"}]
                        }]
                    },
                    {
                        "description": "是否有半成品?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "請說明半成品的運送方式",
                            "type": "oeq",
                        },{
                            "condition": "是",
                            "description": "您如何確保運送工具在載運有機半成品前已徹底清潔？",
                            "type": "oeq",
                        },{
                            "condition": "是",
                            "description": "前述檢查清潔過程是否做成紀錄?",
                            "type": "scq",
                            "options": ["是", "否"]
                        }]
                    },
                    {
                        "description": "請說明成品出貨的包裝方式?",
                        "type": "mcq",
                        "options": ["散裝乾貨", "網袋", "液態桶/桶裝", "鋁箔袋", "金屬桶", "紙桶", "硬卡紙箱", "紙袋", "塑膠器皿", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "出貨時，您是否自行做運送?",
                        "type": "mcq",
                        "options": ["自己", "委外"],
                        "questions": [{
                            "condition": "委外",
                            "description": "如果委由運送公司運送，您是否告知他們有機加工分裝流通的要求？",
                            "type": "scq",
                            "options": ["是", "否"]
                        }]
                    },
                    {
                        "description": "運送工具是否也運送非有機產品或禁用資材?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "如“是”，您如何確保進貨的交通工具在載運有機產品前已徹底清潔，以避免污染？",
                            "type": "oeq",
                        }]
                    },
                    {
                        "description": "前述檢查清潔過程是否做成紀錄？",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "有機產品和非有機產品，是否同時使用同一工具運送?",
                        "type": "scq",
                        "options": ["是", "否"],
                        "questions": [{
                            "condition": "是",
                            "description": "如 “是”，請勾選隔離有機產品的措施?",
                            "type": "mcq",
                            "options": ["使用不同的棧板", "棧板標示「有機」", "以收縮膜包覆有機產品", "在運送工具內分區", "裝在密閉容器裡", {"value": "其他", "elaboration": "請說明"}]
                        }]
                    },
                    {
                        "description": "現場工作人員之操作是否符合衛生要求之管理?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "與食品直接接觸的工作人員是否每年定期接受健康檢查（法規要求之項目含A 型肝炎－IgG及IgM、肺結核、傷寒⋯）?",
                        "type": "scq",
                        "options": ["是", "否"]
                    }
                ]
            },
            {
                "subject": "有害生物防治",
                "description": [
                    "必需使用預防有害生物防治管理措施，例如移除病蟲的棲息地、食物來源、生育地、防止進入處理措施等。",
                    "防治措施可為機械性、物理性控制方法，如：陷阱、光線、聲音等；或相關有機法規所列之誘餌或驅蟲劑。",
                    "若上述措施無法有效預防或控制，可使用所申請之相關有機法規所允用之非合成或合成物質。",
                    "若上述方法仍不能有效控制，而需使用未列於相關法規所允用之物質，應說明使用方法及如何避免該類物質接觸有機產品之措施，並經驗證機構同意後始得以使用。",
                    "使用生物防治資材必須保持紀錄，並列入有機驗證申請書內。",
                    "請附上一份顯示出有害生物陷阱和有害生物監測器位置的設施圖；如果適用的話，請提出用以控制有害生物的資材之安全資料表（SDS）及∕或相關的標示資料。"
                ],
                "questions": [
                    {
                        "description": "您使用何種有害生物防治系統?",
                        "type": "scq",
                        "options": [
                            {"value": "自行管理", "elaboration": "貴公司管理人"},
                            {"value": "委託有害生物防治服務業者", "elaboration": "請提供服務業者名稱、地址、電話及聯絡人資料"}
                        ]
                    },
                    {
                        "description": "請勾選所有您常遇到的有害生物問題(可複選)",
                        "type": "mcq",
                        "options": ["昆蟲類", "爬蟲類", "老鼠", "蜘蛛", "鳥類", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "請勾選所有您常運用的有害生物防治管理措施-預防措施(可複選)",
                        "type": "mcq",
                        "options": [
                            "維護良好的衛生", "清理外溢的產品", "驅離",
                            "割草", "移除棲息地/食物來源", "封閉門窗", "修補破洞、裂縫等", "窗戶加裝紗網、通風…等", "進料之蟲害檢查", "空氣簾", "空氣浴塵室",
                            "消毒", "維持正壓", "塑膠簾", {"value": "其他", "elaboration": "請說明"}
                        ]
                    },
                    {
                        "description": "請勾選所有您常運用的有害生物防治管理措施-物理及機械措施(可複選)",
                        "type": "mcq",
                        "options": ["超音波", "照明設施", "黏板", "溫度控制", "捕蟲燈", "費洛蒙誘捕器", "器械陷阱", "冰凍處理", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "請勾選所有您常運用的有害生物防治管理措施-其他措施(可複選)",
                        "type": "mcq",
                        "options": ["燻蒸", "噴霧", "二氧化碳", "矽藻土", "氮氣", "除蟲菊或其天然萃取物", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "請列出自行管理或委託有害生物防治業者之生物防治資材資訊",
                        "type": "oeq",
                        "format": {
                            "multiple": true,
                            "fields": ["施用資材", "防治之有害生物", "施用地點", "施用方法", "最後使用日期"]
                        }
                    },
                    {
                        "description": "是否保存所有施用有害生物防治資材之紀錄?",
                        "type": "scq",
                        "options": ["是", "否", "不適用"],
                        "questions": [
                            {
                                "condition": "(是|否)",
                                "description": "是否有任何有害生物防治資材，為有機法規所禁用的?",
                                "type": "scq",
                                "options": ["是", "否"],
                                "questions": [{
                                    "condition": "是",
                                    "description": "請檢附有害生物防治計畫，並列出所有避免與有機產品、原料或包裝材料接觸的措施，及有害生物防治所使用資材、施作方法、區域、時間、頻率、防護措施等)",
                                    "type": "seq",
                                    "format": {
                                        "multiple": false,
                                        "fields": ["上傳檔案: file"]
                                    }
                                }]
                            }
                        ]
                    },
                    {
                        "description": "請勾選您所執行的所有廢棄物管理措施(可複選)",
                        "type": "mcq",
                        "options": ["現場清理", "資材回收", "每日清理垃圾", "堆肥", "廢棄物掩埋", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "您的廢棄物管理系統，是否能斷除有害生物生存空間與/或食物來源?",
                        "type": "scq",
                        "options": ["是", {"value": "否", "elaboration": "請說明"}]
                    }
                ]
            },
            {
                "subject": "建立文件",
                "description": [
                    "所有的操作紀錄須保留5年。",
                    "有機產品須能由原料進貨一直追蹤至成品銷售。",
                    "有機原料必須確認經有機驗證。",
                    "有機產品的產出量須與有機原料進貨量平衡。",
                    "所有的相關文件必須標明（示）產品為「有機」的；所有的紀錄必須隨時提供給稽核員和驗證機構。",
                    "基於美國－加拿大對等協議所生產，出口或使用進口的有機產品，其有機驗證證書必須顯示“Certified in compliance with the terms of the US-Canada Organic Equivalency Arrangement”的聲明"
                ],
                "questions": [
                    {
                        "description": "有機加工分裝流通過程中(進料)，您做了下列哪些紀錄?",
                        "type": "mcq",
                        "options": ["購物訂單", "合約", "發票", "收據", "提單", "海關報單", "過磅單據", "分析測試證書", "交易證明", "進口有機農產品同意文件", "有機驗證證書",
                                    "收貨紀錄", "品質測試報告", "非基因改造原料確認書", "未使用下水道污泥處理之原料確認書", "未經放射線照射所生產或處理之原料確認書",
                                    "「有機」產品中使用非有機原料是因為市面上無法買到有機原料之文件證明", "收貨摘要報告 ", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "有機加工分裝流通過程中(製程中)，您做了下列哪些紀錄?",
                        "type": "mcq",
                        "options": ["原料檢查表", "混合調製報告", "生產報告", "設備清潔紀錄", "衛生日誌", "包裝紀錄", "生產摘要報告", "品管報告", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "有機加工分裝流通過程中(倉儲)，您做了下列哪些紀錄?",
                        "type": "mcq",
                        "options": ["原料庫存紀錄", "成品庫存紀錄", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description": "有機加工分裝流通過程中(出貨)，您做了下列哪些紀錄?",
                        "type": "mcq",
                        "options": ["出貨紀錄", "運送工具檢查／清潔表", "提單", "過磅單據", "購貨訂單", "銷售訂單", "售貨發票", "檢疫證明書", "出口報單", "交易證明",
                                    "有機驗證證書", "運送摘要紀錄", "銷售摘要紀錄", {"value": "其他", "elaboration": "請說明"}]
                    },
                    {
                        "description" :"是否所有相關紀錄皆標示有機產品為“有機”?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description" :"紀錄是否可由產品追蹤到所有的原料?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description" :"紀錄是否可確保有機原料和有機產品的進出平衡?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description" :"是否保有所有產品之申訴、抱怨、爭議紀錄及矯正相關程序?",
                        "type": "scq",
                        "options": ["是", "否"]
                    },
                    {
                        "description": "紀錄保存多久?",
                        "type": "oeq",
                    },
                    {
                        "description": "請說明產品之轉換率、损耗率及其來源依據資料?",
                        "type": "oeq",
                    }
                ]
            }
        ]
    }


export default processingApplicationQuestionnaires;